// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToggleSwitch_switchContainer__h7e2m {
  position: relative;
  display: flex;
  margin: 0 auto;
  height: 40px;
  width: 280px;
  background-color: var(--bg-color);
  border-color: var(--border-color);
  border-width: 4px;
  border-style: solid;
  border-radius: 20px;
  cursor: pointer;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);
  -webkit-tap-highlight-color: transparent;
}

.ToggleSwitch_switchOption__TZ31e {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color);
  z-index: 2;
  transition: color 0.3s ease-in-out;
  -webkit-user-select: none;
          user-select: none;
}

.ToggleSwitch_switchOption__TZ31e.ToggleSwitch_active__DIe6n {
  color: var(--text-color);
}

.ToggleSwitch_slider__iphaX {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 50%;
  background: var(--hover-color);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
  z-index: 1;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.ToggleSwitch_slider__iphaX.ToggleSwitch_right__Ozs4o {
  transform: translateX(100%);
}
`, "",{"version":3,"sources":["webpack://./src/components/ToggleSwitch.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".switchContainer {\n  position: relative;\n  display: flex;\n  margin: 0 auto;\n  height: 40px;\n  width: 280px;\n  background-color: var(--bg-color);\n  border-color: var(--border-color);\n  border-width: 4px;\n  border-style: solid;\n  border-radius: 20px;\n  cursor: pointer;\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.switchOption {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n  height: 100%;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--text-color);\n  z-index: 2;\n  transition: color 0.3s ease-in-out;\n  user-select: none;\n}\n\n.switchOption.active {\n  color: var(--text-color);\n}\n\n.slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 50%;\n  background: var(--hover-color);\n  border-radius: 15px;\n  transition: transform 0.3s ease-in-out;\n  z-index: 1;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n}\n\n.slider.right {\n  transform: translateX(100%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchContainer": `ToggleSwitch_switchContainer__h7e2m`,
	"switchOption": `ToggleSwitch_switchOption__TZ31e`,
	"active": `ToggleSwitch_active__DIe6n`,
	"slider": `ToggleSwitch_slider__iphaX`,
	"right": `ToggleSwitch_right__Ozs4o`
};
export default ___CSS_LOADER_EXPORT___;
